/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { defineComponent } from 'vue';
import { render } from '../lib';
import { VmScrim } from '@vime/core';
import { define } from '../lib';
define('vm-scrim', VmScrim);
export default defineComponent({
    emits: [],
    methods: {},
    render: render('vm-scrim', []),
});
//# sourceMappingURL=Scrim.js.map